import React from 'react';
import { Typography } from 'antd';
import { ClassPage } from "./components/ClassPage";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { useParams } from "react-router-dom";
import { _T } from '../../../../base-react/src/Localization';
const { Title } = Typography;
export const Classes = () => {
    const { event_id, competition_id } = useParams();
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('class.plural')))),
        React.createElement(BodyContainer, null,
            React.createElement(ClassPage, { event_id: event_id, competition_id: competition_id }))));
};
